import { useSubscriptionContext } from '@/context/SubscriptionContext';

export const useTrialEligibility = () => {
    const {
        currentOrganisationSubscription,

        isCurrentSubscriptionActive,
        isCurrentSubscriptionInternalTrial,
    } = useSubscriptionContext();

    const hadIAPSubscriptionBefore =
        Boolean(currentOrganisationSubscription) &&
        !isCurrentSubscriptionInternalTrial;
    const internalTrialExpired =
        !isCurrentSubscriptionActive && isCurrentSubscriptionInternalTrial;

    const isFreeTrialEligible =
        !hadIAPSubscriptionBefore || internalTrialExpired;

    return isFreeTrialEligible;
};
